module.exports = __webpack_public_path__ + "img/ic_medium_podcast.ee8feb16.svg";